import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getPracticePlantProtections, getPracticePlantProtectionsAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_PLANT_PPROTECTION } from "consts";

import { PracticePlantProtection, WithInjectedName } from "models";

export const useGetPracticePlantProtections = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getPracticePlantProtectionsAdmin : getPracticePlantProtections;

  return useQuery<Array<WithInjectedName<PracticePlantProtection>>>({
    queryKey: [GET_PRACTICES_PLANT_PPROTECTION, isAdmin],
    queryFn: () => queryFn().then((p) => p.map((pr) => ({ ...pr, name: t(`plantProtections.${pr.translationSlug}`) }))),
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
